module.exports = __webpack_public_path__ + "assets/img/puddle.08e37d4f.png";